// SPEC-301 §3 (RF-VAL-03): "mantener la sesión iniciada" está activo por
// defecto — uso de mostrador, con reingresos frecuentes durante el turno.
//
// `core/http/client.ts` (`bearerToken` en `RequestOptions`) declara
// explícitamente que no sabe de dónde sale el token ni dónde se guarda: esa
// decisión es de esta superficie. `localStorage` sobrevive a cerrar el
// navegador (el comportamiento por defecto que pide RF-VAL-03);
// `sessionStorage` se limpia al cerrar la pestaña, para quien decide
// desactivar el checkbox en un dispositivo compartido.
const STORAGE_KEY = "sc-validator-session";

export interface StoredValidatorSession {
  token: string;
  expiresAt: string;
  userName: string | null;
  placeName: string | null;
  // SPEC-302 §2 (cabecera del inicio): ciudad y tipo del lugar, para «{userName}
  // · {placeCity}» y para futuras pantallas que distingan comercio de taller.
  // Aditivo sobre SPEC-301 (`ValidatorSession.place.city`/`.type`, opcional en
  // el contrato) — `null` cuando el lugar no trae esos campos.
  placeCity: string | null;
  placeType: "merchant" | "workshop" | null;
}

export function saveValidatorSession(
  session: StoredValidatorSession,
  keepSession: boolean,
): void {
  const raw = JSON.stringify(session);
  const store = keepSession ? localStorage : sessionStorage;
  const other = keepSession ? sessionStorage : localStorage;
  store.setItem(STORAGE_KEY, raw);
  other.removeItem(STORAGE_KEY);
}

export function loadValidatorSession(): StoredValidatorSession | null {
  const raw =
    localStorage.getItem(STORAGE_KEY) ?? sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as StoredValidatorSession;
  } catch {
    return null;
  }
}

export function clearValidatorSession(): void {
  localStorage.removeItem(STORAGE_KEY);
  sessionStorage.removeItem(STORAGE_KEY);
}
